import LazyLoad from "vanilla-lazyload";
import LocomotiveScroll from 'locomotive-scroll';
import InputPhone from "./components/inputs/inputPhone";
import Input from "./components/inputs/input";
import validationMessages from "./components/inputs/validationMessages";
import IMask from "imask";
import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";
import ModalDispatcher from "./components/modalDispatcher";
import Dropdown from './components/dropdown';

import formSubmit from "./components/form";
import cookieTooltip from "./components/cookieTooltip";
import headerDropdown from "./components/headerDropdown";
import headerLocationDropdown from "./components/headerLocationDropdown";
import complexMainSlider from "./components/sliders/complexMainSlider";
import mapWidget from "./components/mapWidget";
import complexProgressSlider from "./components/sliders/complexProgressSlider";
import fullGallerySlider from "./components/sliders/fullGallerySlider";
import apartmentLayoutsSlider from "./components/sliders/apartmentLayoutsSlider";
import projectMoreSlider from "./components/sliders/projectMoreSlider";
import tab from "./components/faqTabs";
import contactsSlider from "./components/sliders/contactsSlider";
import teamSlider from "./components/sliders/teamSlider";
import apartmentNewSliders from "./components/sliders/apartmentNewSliders";
import apartmentSecSlider from "./components/sliders/apartmentSecSlider";
import tabsController from "./components/tabsController";
import mortgageCalc from "./components/mortgageCalc";
import search from "./components/search";
import lightGallery from "lightgallery";
import lgZoom from 'lightgallery/plugins/zoom'
import lgRotate from 'lightgallery/plugins/rotate'
import InputPrice from "./components/inputs/inputPrice";
import npSuggestionsSlider from "./components/sliders/npSuggestionsSlider";


setTimeout(() => {
    document.querySelector('body').classList.add('on-loaded');
}, 1000)

document.addEventListener("DOMContentLoaded", _ => {


    if (!sessionStorage.utm) {
        const utm = [...window.location.href.matchAll(/utm_([^=]+)=([^&]*)/g)].reduce((acc, [, k, v]) => (acc[k] = v, acc), {})
        sessionStorage.setItem('utm', JSON.stringify(utm))
    }


    if (!sessionStorage.activeSession) {
        // setTimeout(_ => {
        //   document.querySelector('.preloader').classList.add('is-ready');
        //   sessionStorage.activeSession = 1;
        // }, 1000)

        setTimeout(() => {
            document.querySelector('body').classList.add('disabled');
            // sessionStorage.setItem('site', 'enter');
        }, 3500)

        sessionStorage.activeSession = 1;
    } else {
        document.querySelector('body').classList.add('disabled');
    }
    search.init();
    formSubmit();
    cookieTooltip();

    headerDropdown();
    headerLocationDropdown();
    mapWidget();
    tabsController();

    complexMainSlider();
    complexProgressSlider();
    fullGallerySlider();
    apartmentLayoutsSlider();
    projectMoreSlider();
    contactsSlider();
    teamSlider();
    apartmentNewSliders();
    apartmentSecSlider();

    npSuggestionsSlider();

    if (document.querySelector('.mortgage_calc')) {
        mortgageCalc();
    }


    document.querySelectorAll('[data-dropdown]').forEach(el => {
        new Dropdown(el);
    })

    ModalDispatcher.init();

    if (document.querySelector('[data-tab-wrapper]')) {
        tab(document.querySelector('[data-tab-wrapper]'));
    }

    let scroll = new LocomotiveScroll({
        getDirection: true,
    });

    const lazyLoadInstance = new LazyLoad({
        elements_selector: '[data-lazy]',
        callback_loaded: el => el.parentElement.classList.add('is-loaded')
    });
    document.addEventListener('ll::needUpdate', _ => {
        lazyLoadInstance.update();
    });

    setTimeout(_ => {
        scroll.update();


        scroll.on('scroll', (args) => {
            if (args.scroll.y > 100) {
                document.body.dataset.scrollDirection = args.direction;
            }
            else {
                document.body.dataset.scrollDirection = '';
            }
        });

        scroll.on('call', func => {
            statsCounter();
        })
    }, 0)

    // PRIVACY

    if (document.querySelector('.privacy')) {
        let containers = document.querySelectorAll('[data-sector]');
        let links = document.querySelectorAll('.privacy_pagination__link');
        let anchorLinks = document.querySelectorAll('[data-anchor-link]');

        function intersectionHandler(entries) {
            [].forEach.call(entries, function (entry) {
                let sector = entry.target.dataset.sector;
                let link = [].find.call(links, link => link.getAttribute('href').replace('#', '') === sector);
                if (entry.isIntersecting) {
                    link.classList.add('is-active');
                }
                else {
                    link.classList.remove('is-active');
                }

            });
        }

        let observerSector = new IntersectionObserver(intersectionHandler, { threshold: .1, rootMargin: '-20% 0% -50%' });
        [].forEach.call(containers, function (entry) {
            observerSector.observe(entry);
        });

        [].forEach.call(anchorLinks, function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();

                const sector = link.getAttribute('href').replace('#', '');
                const pos = document.querySelector(`[data-sector="${sector}"]`).offsetTop;

                if (document.querySelector('.mortgage_calc')) {
                    scroll.scrollTo(pos + 800);
                } else {
                    scroll.scrollTo(pos);
                }
            });
        });

    }

    // ANCHOR LINKS

    const anchorLinks = document.querySelectorAll('[data-anchor]');

    anchorLinks.forEach(link => {
        link.addEventListener('click', evt => {
            evt.preventDefault();
            const target = document.querySelector(`[data-scroll-id=${link.dataset.anchor}]`);
            scroll.scrollTo(target);
        });
    });

    // INPUTS

    const inputs = document.querySelectorAll('.input_wrapper__input');


    document.querySelectorAll('[name="phone"]').forEach((el) => {
        new InputPhone(el);
    });

    document.querySelectorAll('[name="price[min]"], [name="price[max]"], [name="np_price[min]"], [name="np_price[max]"]').forEach((el) => {
        new InputPrice(el);
    });

    inputs.forEach(item => {
        new Input(item, validationMessages);
    });



    document.addEventListener('click', e => {
        const offersBtn = e.target.closest('[data-offer-id]');
        if (!offersBtn) return;
        sessionStorage.setItem('offer_id', offersBtn.dataset.offerId);
    })

    if (!localStorage.getItem('citySelected')) {
        document.dispatchEvent(new CustomEvent('needModal', { detail: 'modal_cities' }))
    }
    document.addEventListener('click', async e => {
        const cityBtn = e.target.closest('[data-city-id]');
        if (!cityBtn) return;
        localStorage.setItem('citySelected', 1);
        const data = new FormData();
        data.append('city_id', cityBtn.dataset.cityId);
        const req = await fetch('/api/city', {
            method: 'POST',
            body: data
        });
        const res = await req.json();
        if (res.success) {
            window.location.reload();
        }
    });

    document.querySelectorAll('[data-light-gallery]').forEach(el => {
        lightGallery(el, {
            plugins: [lgZoom, lgRotate],
            infiniteZoom: true,
            actualSize: false,
            showZoomInOutIcons: true,
            flipHorizontal: false,
            flipVertical: false,
            appendCounterTo: '.lg-components',
            appendSubHtmlTo: '.lg-outer',
            mobileSettings: {
                showCloseIcon: true
            }
        });

    });

    document.addEventListener('click', e => {
        const btn = e.target.closest('[data-dynamic-lightgallery]');
        if (!btn) return;
        const lg = lightGallery(btn, {
            dynamic: true,
            dynamicEl: btn.dataset.dynamicLightgallery.split('#|#').map(src => ({ src: src.split('$|$')[0], subHtml: src.split('$|$')[1] })),
            plugins: [lgZoom, lgRotate],
            infiniteZoom: true,
            actualSize: false,
            showZoomInOutIcons: true,
            flipHorizontal: false,
            flipVertical: false,
            appendCounterTo: '.lg-components',
            appendSubHtmlTo: '.lg-outer',
            mobileSettings: {
                showCloseIcon: true
            }
        });
        lg.openGallery();

    })

    document.addEventListener('catalog::changed', () => {
        document.querySelectorAll('[data-light-gallery]').forEach(el => {
            lightGallery(el, {
                plugins: [lgZoom, lgRotate],
                infiniteZoom: true,
                actualSize: false,
                showZoomInOutIcons: true,
                flipHorizontal: false,
                flipVertical: false,
                appendCounterTo: '.lg-components',
                appendSubHtmlTo: '.lg-outer',
                mobileSettings: {
                    showCloseIcon: true
                }
            });

        })
        document.querySelectorAll('[data-dropdown]').forEach(el => {
            if (!el.dropdown) {
                new Dropdown(el);
            }
        })
    });

});
